import { Select } from '@/components/ui/select';
import type { UserReference } from '../types';

interface LeadFiltersProps {
  onFilterChange: (filter: FilterType) => void;
  onAssignedToChange: (userId: number | undefined) => void;
  currentFilter: FilterType;
  users: UserReference[];
  selectedAssignedToId?: number;
}

export type FilterType = 'all-open' | 'unassigned' | 'recent-no-gos' | 'recently-closed' | 'by-estimator';

export function LeadFilters({
  onFilterChange,
  onAssignedToChange,
  currentFilter,
  users,
  selectedAssignedToId,
}: LeadFiltersProps) {
  const filterLinks: { id: FilterType; label: string }[] = [
    { id: 'recent-no-gos', label: "No-Go's" },
    { id: 'recently-closed', label: 'Closed' },
    { id: 'by-estimator', label: 'Estimator' },
    { id: 'all-open', label: 'Open' },
    { id: 'unassigned', label: 'Unassigned' },
  ];

  return (
    <div className="flex items-center gap-1">
      {filterLinks.map((link, index) => (
        <div key={link.id} className="flex items-center">
          <button
            type="button"
            onClick={() => onFilterChange(link.id)}
            className={`px-2 py-1 text-sm transition-colors ${
              currentFilter === link.id
                ? 'text-secondary font-semibold underline'
                : 'text-gray-600 hover:text-secondary hover:underline'
            }`}
          >
            {link.label}
          </button>
          {index < filterLinks.length - 1 && (
            <span className="text-gray-400 mx-1">|</span>
          )}
        </div>
      ))}

      {currentFilter === 'by-estimator' && (
        <Select
          value={selectedAssignedToId?.toString() || ''}
          onChange={(e) => {
            onAssignedToChange(e.target.value ? Number(e.target.value) : undefined);
          }}
          className="ml-2 w-48 h-8 text-sm rounded border border-gray-300"
        >
          <option value="">Select Estimator</option>
          {users.map((user) => (
            <option key={user.id} value={user.id}>
              {user.name}
            </option>
          ))}
        </Select>
      )}
    </div>
  );
}
